module.exports = __webpack_public_path__ + "img/pos5_s3.c86e2f7c.png";